import React, { Component } from "react";
import Dashboard from "views/Dashboard/Dashboard.jsx";
import UserProfile from "../views/User/UserProfile";
// import Settings from "../views/User/Settings";
import CryptoJS from "crypto-js";
let given_name = ''
if(localStorage.getItem('given_name') != null){
  JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('given_name'), 'secretpass').toString(CryptoJS.enc.Utf8))
}
var userDashRoutes = [
  {
    collapse: true,
    path: "/user",
    name: given_name,
    // icon: HearingIcon,
    state: "openAvatar",
    views: [
      {
        path: "/userProfile",
        name: "My Profile",
        component: UserProfile
      }
      // {
      // path: "/user/editProfile",
      // name: "Edit Profile",
      // // mini: "EP",
      // component: EditProfile
      // },
      // {
      // path: "/userSettings",
      // name: "Settings",
      // component: Settings
      // }
    ]
  }
];
export default userDashRoutes;



// WEBPACK FOOTER //
// ./src/routes/userDashboard.jsx